import { useState, useCallback } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Partners from "@/components/Partners";
import Products from "@/components/Products";
import WhyUs from "@/components/WhyUs";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import QuoteDialog from "@/components/QuoteDialog";
import FloatingActions from "@/components/FloatingActions";

export default function HomePage() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [defaultType, setDefaultType] = useState("car");

  const openQuote = useCallback((type) => {
    if (typeof type === "string") setDefaultType(type);
    setQuoteOpen(true);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-white">
      <Header onQuoteClick={() => openQuote()} />
      <main>
        <Hero onQuoteClick={() => openQuote()} />
        <Partners />
        <Products onQuoteClick={openQuote} />
        <WhyUs />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
      <QuoteDialog
        open={quoteOpen}
        onOpenChange={setQuoteOpen}
        defaultType={defaultType}
      />
    </div>
  );
}
